/**
 * Top bar component for transactions
 * 
 * Properties:
 * 
 *      textLeft:   string, text to be displayed at left side
 *      refLabel:   string, label for link to print closing
 *      amount:     number, representing saldo
 *      handler:    function, callback to trigger by clicking on ref
 */

import React from "react";
import t from '../../../helpers/t';
import { FormatHelper, Biscuit } from "../../../../utils";

const TransactionsTopBar = (props) => {

    return (
        <div style={{width: "100%",height: "50px", paddingTop: "3px", borderBottom: "1px solid rgb(227, 227, 227)", fontSize: "0.85em", fontWeight: "bold"}}>
            <div className="inb-c-item-details-row row" style={{paddingRight: '0px'}}>
                <div className="medium-4 small-4 column">
                    <span>{props.textLeft}</span>
                </div>
                <div className="medium-4 small-4 column text-center">
                    {/*<a href='#' onClick={props.handler}>{props.refLabel}</a>*/}
                </div>
                <div className="medium-4 small-4 column text-right">
                    <span>{FormatHelper.currencyFormat(props.amount) + " " + Biscuit.get('client.currency')}</span>
                </div>
            </div>
        </div>
    );
};
export default TransactionsTopBar;